import axios from 'axios'
import { setupCache } from 'axios-cache-adapter'

const cache = setupCache({
  maxAge: 30 * 60 * 1000
})

const axiosCached = axios.create({
  adapter: cache.adapter
})

export default axiosCached
